import { useEffect } from "react";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { EditorState } from "lexical";

type EditorStatePluginProps = {
    onChange?: (value: EditorState) => void;
};

export function EditorStatePlugin({ onChange }: EditorStatePluginProps) {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        return editor.registerUpdateListener(({ editorState }) => {
            onChange?.(editorState);
        });
    }, [editor, onChange]);

    return null;
}
